import React from 'react'
import { styled } from '@moonpig/launchpad-utils'
import { system as s } from '@moonpig/launchpad-system'

const escapeRegExp = (text: string) => {
  const escapedValue = text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&')
  return text.length === 1
    ? new RegExp(`\\b(${escapedValue})`, 'gi')
    : new RegExp(`(${escapedValue})`, 'gi')
}

const StyledHighlightedSelection = styled.span`
  white-space: pre;
  ${s({ typography: 'typeBodyLabel' })}
`
const StyledRegularSelection = styled.span`
  white-space: pre;
  ${s({ typography: 'typeBodyText' })}
`

export const HighlightText = ({
  text,
  value,
}: {
  text: string
  value: string
}) => {
  const parts = text.split(escapeRegExp(value))

  return (
    <>
      {parts.map((part, i) => {
        if (part.toLowerCase() !== value.toLowerCase()) {
          return (
            // eslint-disable-next-line react/no-array-index-key
            <StyledHighlightedSelection key={i}>
              {part}
            </StyledHighlightedSelection>
          )
        }
        if (part.length) {
          // eslint-disable-next-line react/no-array-index-key
          return <StyledRegularSelection key={i}>{part}</StyledRegularSelection>
        }
        /* istanbul ignore next */
        return null
      })}
    </>
  )
}
